import { NavigateLink } from '@/components/navigate/NavigateLinks';
import { NavigateFunction } from 'react-router-dom';

export const businessCommercesPageBreadcrumbs = (
  _navigate: NavigateFunction
): NavigateLink[] => [{ label: 'Inicio', to: '/' }];

export const childrenBusinessCommercesPageBreadcrumbs = (
  _navigate: NavigateFunction
): NavigateLink[] => [
  { label: 'Sistema de envíos', to: '/business-commerces' },
];

export const childrenShippingsCommercesPageBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [
  ...childrenBusinessCommercesPageBreadcrumbs(navigate),
  { label: 'Envíos', onClick: () => navigate('/business-commerces/shippings') },
];

export const casesPageBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => childrenBusinessCommercesPageBreadcrumbs(navigate);

export const supportMaterialPageBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => childrenBusinessCommercesPageBreadcrumbs(navigate);

export const supportManualPageBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [
  ...supportMaterialPageBreadcrumbs(navigate),
  {
    label: 'Material de apoyo',
    onClick: () => navigate('/business-commerces/support-material'),
  },
];

export const childrenBusinessCommercesCommercePageBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [
  ...childrenBusinessCommercesPageBreadcrumbs(navigate),
  {
    label: 'Mi comercio',
    onClick: () => navigate('/business-commerces/commerce'),
  },
];

export const childrenBusinessCommercesBranchesPageBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [
  ...childrenBusinessCommercesCommercePageBreadcrumbs(navigate),
  {
    label: 'Sucursales',
    onClick: () => navigate('/business-commerces/commerce/branches'),
  },
];
